/**
 * Column/row definitions for the Candid Upload tab table.
 *
 * @module candidUploadTable
 */
import {
  TableCellType,
  TableHeader,
} from "../../../../components/custom-table/table";
import { CandidUploadTableKeys } from "./types/candidUploadTableRow";

/** Re-export so existing table imports can keep using this module. */
export { CandidUploadTableKeys };

/** Column headers for the Candid Upload CustomTable. */
export const CandidUploadTableHeaders: TableHeader[] = [
  {
    label: "Updated At",
    key: CandidUploadTableKeys.UpdatedAt,
    order: 1,
    width: 32,
    type: TableCellType.STRING,
  },
  {
    label: "Type",
    key: CandidUploadTableKeys.Type,
    order: 2,
    width: 50,
    type: TableCellType.STRING,
  },
  {
    label: "Status",
    key: CandidUploadTableKeys.Status,
    order: 3,
    width: 10,
    type: TableCellType.BADGE,
  },
  {
    label: "",
    key: CandidUploadTableKeys.View,
    order: 4,
    width: 8,
    type: TableCellType.ICON,
  },
];
